import { render, staticRenderFns } from "./VMenu.vue?vue&type=template&id=26a052e6&scoped=true"
import script from "./VMenu.vue?vue&type=script&lang=js"
export * from "./VMenu.vue?vue&type=script&lang=js"
import style0 from "./VMenu.vue?vue&type=style&index=0&id=26a052e6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a052e6",
  null
  
)

export default component.exports